<template>
    <div
        :class="['edit-modal-mask', bModalEffectMask ? 'fade-in' : 'fade-out']"
        v-show="bModalMaskShow"
    >
        <transition name="collapse-list">
            <div class="edit-modal" v-show="bEditModalShow">
                <div class="edit-modal-header">
                    {{ title }}
                    <div class="close" @click="closeModal()"></div>
                </div>
                <div class="edit-modal-content">
                    <div class="edit-goods-list">
                        <ul v-if="oGoodsInfo.arrWind.length">
                            <li
                                v-for="(item, index) in oGoodsInfo.arrWind"
                                :key="index"
                            >
                                <div class="img-box">
                                    <img :src="item.mobile_thumb" alt="" />
                                </div>
                                <div class="goods-info">
                                    <div class="goods-name">
                                        <span>{{ item.mark }}</span><br>
                                        <span>{{ item.goods_name }}</span>
                                    </div>
                                    <div class="goods-attr">
                                        <div>重要参数：</div>
                                        <div
                                            v-for="(
                                                attrItem, attrIndex
                                            ) in item.attr_two"
                                            :key="attrIndex"
                                        >
                                            {{ attrItem.attr_name }}:{{
                                                attrItem.attr_value
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="count">x {{item.nNum}}</div> -->
                                <div
                                    class="edit-count"
                                    @click.stop="openPiker(index)"
                                >
                                    <p>{{ item.nNum || "选择数量" }}</p>
                                </div>
                                <!-- <div class="yx"></div> -->
                                <div class="floor-icon">
                                    {{ item.floor | floorText }}
                                </div>
                                <div
                                    class="delete"
                                    @click="deletedChange(index)"
                                ></div>
                            </li>
                        </ul>
                        <div class="no_ul_shopp" v-else>请选择所需的产品</div>
                    </div>
                    <div class="edit-modal-top">
                        <div class="search">
                            <img
                                src="@/assets/images/ant/search.png"
                                alt=""
                                @click="searchChange()"
                            />
                            <input
                                type="text"
                                name=""
                                id=""
                                v-model="sKeyWord"
                            />
                        </div>
                        <div class="select" @click="$refs.calssPicker.show()">
                            <div class="name">{{ sClassValue[0].value }}</div>
                            <div class="select-icon"></div>
                        </div>
                    </div>
                    <div class="goods-list"
                        v-infinite-scroll="loadMore"
                        infinite-scroll-disabled="true"
                        infinite-scroll-distance="0"
                        infinite-scroll-immediate-check="true"
                    >
                        <!-- <pull-to
                            :distance-index="3"
                            :top-load-method="downRefresh"
                            :bottom-load-method="upRefresh"
                            :is-bottom-bounce="true"
                            bottom-block-height:0
                            top-block-height:0
                        > -->
                            <div v-if="!isNotData">
                                <div
                                    class="goods-item"
                                    v-for="(item, index) in arrGoodsList"
                                    :key="index"
                                >
                                    <div class="img-box">
                                        <img
                                            v-lazy="item.mobile_thumb"
                                            alt=""
                                        />
                                    </div>
                                    <div class="goods-info">
                                        <p class="goods-name">
                                            <span>{{item.mark}}</span><br>
                                            <span>{{ item.goods_name }}</span>
                                        </p>
                                        <div class="goods-attr">
                                            <div>重要参数：</div>
                                            <div
                                                v-for="(
                                                    attrItem, attrIndex
                                                ) in item.attr_two"
                                                :key="attrIndex"
                                            >
                                                {{ attrItem.attr_name }}:{{
                                                    attrItem.attr_value
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="add-btn"
                                        @click.stop="selectChange(item, index)"
                                    >
                                        添加
                                    </div>
                                    <!-- <div :class="['no-checked', item.checked ? 'checked':'']"></div> -->
                                </div>
                                <div class="dropload-tip" v-if="isToEnd">
                                    我是有底线的
                                </div>
                            </div>
                            <div class="not-data" v-else>暂时还没有数据哦~</div>
                        <!-- </pull-to> -->
                    </div>
                </div>
                <div class="edit-btn">
                    <button class="confirm-btn" @click="closeSearchModal()">
                        确定
                    </button>
                </div>
            </div>
        </transition>
        <!-- 选择暖气分类 -->
        <awesome-picker
            ref="calssPicker"
            :anchor="sClassValue"
            :data="arrClassList"
            :colorConfirm="oPicker.colorConfirm"
            @confirm="classConfirmPicker"
        ></awesome-picker>
        <!-- 选择数量 -->
        <awesome-picker
            ref="picker"
            :anchor="sSelectValue"
            :data="arrSelectList"
            :colorConfirm="oPicker.colorConfirm"
            @confirm="confirmPicker"
        ></awesome-picker>
    </div>
</template>
<script>
import PullTo from "vue-pull-to";
import { getGoodsList } from "@/js/map.js";
export default {
    components: {
        PullTo,
    },
    props: {
        title: {
            type: String,
            default: () => {
                return "";
            },
        },
        bEditModalShow: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        oGoodsInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    filters: {
        floorText(value) {
            let key = value || 0;
            const oFloor = {
                0: "已选",
                1: "一层",
                2: "二层",
                3: "三层",
                4: "四层",
                "-1": "地下室一层",
                "-2": "地下室二层",
            };
            return oFloor[key];
        },
    },
    data() {
        return {
            loading: false, //无限滚动禁止
            nActive: null,
            bModalEffectMask: false, // 动画开关
            bModalMaskShow: false, // mask开关
            sKeyWord: "", //输入文字
            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)",
            },
            // 选择风盘才出现的下拉列表
            arrClassList: [
                { value: "风盘", id: 201 },
                { value: "散热片", id: 215 },
                { value: "地暖管", id: 216 },
            ],
            sClassValue: [{ value: "风盘", id: 201 }],
            nPage: 0, //页码
            arrGoodsList: [],
            isToEnd: false, // 是否到底
            isNotData: true, // 是否有数据
            sSelectValue: [{ value: 1 }], //默认数量
            arrSelectList: [],
        };
    },
    created() {
        for (let i = 1; i <= 50; i++) {
            this.arrSelectList.push({
                value: i,
            });
        }
    },
    watch: {
        bEditModalShow: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.arrClassList.forEach((it, index) => {
                      //  console.log(it.id,this.oGoodsInfo.goods_type_id)
                        if (it.id == this.oGoodsInfo.goods_type_id) {
                            this.sClassValue = [it];
                        }
                    });
                    this.arrGoodsList = [];
                    this.nPage = 0;
                    this.getGoodsList();
                    this.bModalEffectMask = newValue;
                    this.bModalMaskShow = newValue;
                } else {
                    this.nPage = 0;
                    this.sKeyWord = "";
                    this.arrGoodsList = [];
                    this.bModalEffectMask = newValue;
                    setTimeout(() => {
                        this.bModalMaskShow = newValue;
                    }, 500);
                }
            },
        },
    },
    methods: {
        //触底加载
        loadMore(){
            this.nPage++;
            this.getGoodsList();
        },
        //确认选择的产品
        closeSearchModal() {
            if (this.oGoodsInfo.arrWind.length === 0) {
                this.$toast("您还没有选择产品！");
                return false;
            }
            const { bFloor } = this.oGoodsInfo;
          //  console.log(bFloor);
            if (bFloor) {
            } else {
                let arrFwter = Math.max.apply(
                    Math,
                    this.oGoodsInfo.arrWind.map((item) => {
                        return item.new_goods_type_id;
                    })
                );
                //判断是否全为风盘
                if (arrFwter == 201) {
                    let power = 0;
                    this.oGoodsInfo.arrWind.forEach((item) => {
                        if (item.new_goods_type_id == 201) {
                            power += item.power * item.nNum;
                        }
                    });
                    if (power < this.oGoodsInfo.energy_cold) {
                        this.$toast({
                            message: "您选择产品功率过小",
                            duration: 1500,
                        });
                        // return false
                    }
                }
                this.closeModal();
                this.$emit("confirm", {
                    data: this.oGoodsInfo.arrWind,
                    oFloor: {},
                });
            }
        },
        //选择数量
        openPiker(index) {
            this.nActive = index;
            this.$refs.picker.show();
        },
        //删除商品
        deletedChange(index) {
            this.oGoodsInfo.arrWind.splice(index, 1);
        },
        closeModal() {
            this.$emit("update:bEditModalShow", false);
        },
        //选择数量点击事件
        confirmPicker(res) {
            this.oGoodsInfo.arrWind[this.nActive].nNum = res[0].value;
        },
        // 选择分类
        classConfirmPicker(res) {
            this.nPage = 0;
            this.arrGoodsList = [];
            this.sClassValue = [this.arrClassList[res[0].index]];
            this.getGoodsList();
        },
        //添加产品
        selectChange(item, index) {
            if (
                item.new_goods_type_id == 215 &&
                ~this.oGoodsInfo.arrWind.findIndex(
                    (_) => _.new_goods_type_id == 216
                )
            ) {
                this.$toast("您已经选择了地暖管，请勿重复！");
                return false;
            }
            if (
                item.id == 936 &&
                ~this.oGoodsInfo.arrWind.findIndex(
                    (_) => _.new_goods_type_id == 216
                )
            ) {
                this.$toast("您已经选择了地暖管，请勿选择地暖系统");
                return false;
            }
            if (
                item.new_goods_type_id == 216 &&
                ~this.oGoodsInfo.arrWind.findIndex(
                    (_) => _.new_goods_type_id == 215
                )
            ) {
                this.$toast("您已经选择了散热片，请勿重复！");
                return false;
            }
            const active = this.oGoodsInfo.arrWind.findIndex(
                (_) => _.id === item.id
            );
            if (!~active) {
                // 不存在
                if (this.oGoodsInfo.bFloor) {
                    // 选型修改
                    if (
                        this.oGoodsInfo.arrFloor.length === 1 &&
                        this.oGoodsInfo.arrFloor[0].room === 1
                    ) {
                        //只有一层，不用选择楼层
                        item.nNum = 1;
                        item.floor = 1;
                        this.oGoodsInfo.arrWind.unshift(item);
                    } else {
                        // 多层，开启选楼层弹窗
                        this.nActiveFloorIndex = null;
                        this.bShowfloorModal = true;
                        this.nAddIndex = index;
                    }
                } else {
                    // 修改风盘
                    item.nNum = 1;
                    /* 拆分风盘标题为，商品名字、商品型号*/
                    let nTxtIndex = item.goods_name.indexOf("盘");
                    item.sTypeName = item.goods_name.substring(
                        0,
                        nTxtIndex + 1
                    ); //商品名字
                    item.sGoodsName = item.goods_name.substring(nTxtIndex + 1); //商品型号
                    this.oGoodsInfo.arrWind.unshift(item);
                }
            } else {
                // 已存在
                if (this.oGoodsInfo.bFloor) {
                    // 选型修改
                    if (
                        this.oGoodsInfo.arrFloor.length === 1 &&
                        this.oGoodsInfo.arrFloor[0].room === 1
                    ) {
                        //只有一层，不用选择楼层
                        this.oGoodsInfo.arrWind[active].nNum++;
                    } else {
                        // 多层，开启选楼层弹窗
                        this.nActiveFloorIndex = null;
                        this.bShowfloorModal = true;
                        this.nAddIndex = index;
                    }
                } else {
                    // 修改风盘
                    this.oGoodsInfo.arrWind[active].nNum++;
                }
            }
        },
        // 获取产品列表
        async getGoodsList(callback) {
            this.$store.commit("loadSwitch", true);
            let system_id =
                this.oGoodsInfo.system_id === 2 ? this.oGoodsInfo.system_id : 0;
            let type_id =
                this.oGoodsInfo.system_id === 2
                    ? 0
                    : this.oGoodsInfo.goods_type_id || 0;

            // 如果是修改风盘就传下拉选择的值
            if (
                this.oGoodsInfo.goods_type_id === 201 ||
                this.oGoodsInfo.goods_type_id === 215 ||
                this.oGoodsInfo.goods_type_id === 216
            ) {
                type_id = this.sClassValue[0].id;
            }
            const resuqestData = {
                plan: 0,
                system_id: system_id,
                word: this.sKeyWord,
                type_id: type_id,
                page: this.nPage,
                limit: 10,
            };
            const resultData = await getGoodsList(resuqestData);
            resultData.data.data.result.list.forEach((item) => {
                item.nNum = 1;
                item.attr_one = []; // 右边重要卖点
                item.attr_two = []; // 下面参数
                item.attr.forEach((it) => {
                    it.attr_name = it.attr_name
                        .replace(/[\r\n]/g, "")
                        .replace(/\ +/g, ""); // 过滤空格、换行
                    it.attr_value = it.attr_value
                        ? it.attr_value
                              .replace(/[\r\n]/g, "")
                              .replace(/\ +/g, "")
                        : ""; // 过滤空格、换行
                    if (
                        it.attr_mean == 1 ||
                        it.attr_mean == 2 ||
                        it.attr_mean == 3
                    ) {
                        // 右边重要卖点分离
                        item.attr_one.push(it);
                    }
                    if (
                        it.attr_mean == 4 ||
                        it.attr_mean == 5 ||
                        it.attr_mean == 6
                    ) {
                        // 下面参数分离
                        item.attr_two.push(it);
                    }
                });
            });
            if (resultData.data.data.result.list.length === 0) {
                this.isToEnd = true;
            } else {
                this.isToEnd = false;
                this.arrGoodsList = [
                    ...this.arrGoodsList,
                    ...resultData.data.data.result.list,
                ];
            }
            this.$store.commit("loadSwitch", false);
            this.isNotData = this.arrGoodsList.length === 0 ? true : false;
            callback && callback();
        },
        //下拉
        downRefresh(loaded) {
            this.arrGoodsList = [];
            this.nPage = 0;
            this.getGoodsList(() => {
                loaded("done");
            });
        },
        // 上拉加载
        upRefresh(loaded) {
            if (!this.isToEnd) {
                this.nPage++;
                this.getGoodsList(() => {
                    loaded("done");
                });
            } else {
                loaded("done");
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>
